export default {
  setCart: (state, cart) => {
    state.cart = cart;
  },
};
